import { useGetBrokerageAnalyticsQuery } from "../dashBoardApi";
import "./dashboard-sections.css";
import DashboardCard from "./DashboardCard";



const BrokerageOverview = ({ startDate , endDate }) => {
  

  const {
    data : brkData ,
    isLoading : isBrkDataLoading ,
    isFetching : isBrkDataFetching,
    isError : isBrkError  
  } = useGetBrokerageAnalyticsQuery(
    {
      startDate,
      endDate
    },
    {
      skip: !startDate || !endDate // avoid API call if empty
    }
  );

  const respData = brkData?.data;
  const boxes = [
    { 
      key: "total_entered_kg",
      label: "Total Entered KG",
      value: respData?.total_entered_kg ?? 0,
      theme: "orange" 
    },
    { 
      key: "total_sorted_kg",
      label: "Total Sorted (KG)",
      value: respData?.total_sorted_kg ?? 0,
      theme: "orange"
    },
    { 
      key: "total_boxes_packed",
      label: "Total Boxes Packed",
      value: respData?.total_boxes_packed ?? 0,
      theme: "green"
    },
    { 
      key: "total_pasted_boxes_packed",
      label: "Total Paste Boxes Packed",
      value: respData?.total_pasted_boxes_packed ?? 0,
      theme: "green"
    },
    { 
      key: "total_rejected_kg",
      label: "KG Rejected",
      value: respData?.total_rejected_kg ?? 0,
      theme: "red"
    },
  ];


  return (
    <DashboardCard
      title="Brokerage Overview"
      badgeIcon={startDate && endDate
        ? <span className="pko-batch-badge">{startDate} → {endDate}</span>
        : null
      }
    >
      <div className="fqm-grid">
        {boxes.map((b) => (
          <div key={b.key} className={`pp-brokering-box bro-box-${b.theme}`}>
            <div className="pp-brokering-box-label">{b.label}</div>
            <div className="pp-brokering-box-value">
              {isBrkDataLoading
                ? <span className="db-shimmer" style={{ height: 28, width: 60, display: "block" }} />
                : (b.value?? "0")
              }
            </div>
          </div>
        ))}
      </div>
    </DashboardCard>
  );
};

export default BrokerageOverview;
